import { Component, inject, OnInit } from '@angular/core';
import { HttpCoreService } from '@dataclouder/ngx-core';

@Component({
  selector: 'ngx-courses-admin',
  templateUrl: './courses-admin.component.html',
  styleUrls: ['./courses-admin.component.scss'],
  standalone: true,
})
export class CoursesAdminComponent implements OnInit {
  private httpCoreService: HttpCoreService = inject(HttpCoreService);

  async ngOnInit(): Promise<void> {
    const courses = await this.httpCoreService.get('courses');
    console.log(courses);
  }
}
